var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendaryM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6854 3H21V21H3V12.6231H4.38462V11.3077H5.76927V12.6923H4.38462V18.2308H5.8177V16.8462H7.20231V15.4615V14.0769H9.97154V12.6923H11.3562V11.3217H9.98539V9.94404H11.3631V11.3077H12.7408V9.92308H14.1254V7.05691H16.86V5.73475H18.2377V7.11244H16.8946V8.53846H15.51V9.92308H14.1669V11.3077H12.7823V12.6923H11.3977V14.0769H10.013V15.4615H8.67V16.8462H7.28539V18.2308H5.90077V19.6154H14.2085V18.2308H15.5515V19.6154H18.3139V18.2308H16.9708V16.8462H18.3554V18.2308H19.74V15.4615H18.3207V14.0769H19.6985V5.76923H18.2792V4.38462H12.7408V5.6723H14.1254V7.05691H12.7408V5.76923H11.3562V4.38462H12.6854V3ZM16.9361 11.3077H18.2792V14.0769H16.9361V11.3077ZM16.8946 9.92308V11.3077H15.5515V9.92308H16.8946ZM10.0546 16.8462V15.4615H11.3977V16.8462H10.0546ZM11.4392 18.2308V16.8462H14.1669V18.2308H11.4392ZM5.80385 9.91632H7.18154V11.294H5.80385V9.91632ZM11.3492 5.73475H9.97154V7.11244H11.3492V5.73475ZM16.8946 15.4548H15.5169V16.8325H16.8946V15.4548ZM14.1323 14.0769H15.51V15.4546H14.1323V14.0769ZM14.1323 12.6991H12.7546V14.0768H14.1323V12.6991ZM7.18154 8.51799H8.58693V7.11261H9.97154V9.91645H8.58693V9.89568H7.18154V8.51799ZM7.18154 12.6991H5.80385V14.0768H7.18154V12.6991Z",
    fill: "#33F1FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendaryM);
export default __webpack_public_path__ + "static/media/legendary-m.ae44a98b54554823717342f2e2ebb261.svg";
export { ForwardRef as ReactComponent };